/* Sew Yeah storefront navigation accelerator. */
(function () {
  'use strict';
  var prefetched = Object.create(null);
  var excluded = /\/(cart|checkout|account|apps)(\/|$)/;
  function eligible(link) {
    if (!link || !link.href || link.target || link.hasAttribute('download')) return false;
    var url;
    try { url = new URL(link.href, location.href); } catch (error) { return false; }
    return url.origin === location.origin && !excluded.test(url.pathname) &&
      !url.hash && url.href !== location.href && !prefetched[url.href];
  }
  function prefetch(link) {
    if (!eligible(link)) return;
    prefetched[link.href] = true;
    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = link.href;
    hint.as = 'document';
    document.head.appendChild(hint);
  }
  document.addEventListener('pointerover', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var timer = setTimeout(function () { prefetch(link); }, 80);
    link.addEventListener('pointerout', function () { clearTimeout(timer); }, { once: true });
  }, { passive: true });
  document.addEventListener('touchstart', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    prefetch(link);
  }, { passive: true });
}());
